import $ from 'jquery';

class FormModal {
    constructor() {    
    }

    init() {
        this.handleImageModal();     
    }

    handleImageModal() {
        //open carousel modal
        $('body').on('click', '#js-contact-form', (e) => {
            e.preventDefault();
            this.openFormModal();
        });

        //close carousel modal
        $(document).on('click', (e) => {
			if ($(e.target).hasClass('modaal-outer-wrapper')) {
                this.closeModal();
            }
		});  
    }

    closeModal() {
        let form = $('#js-add-form').find('form');
            if (typeof form !== 'undefined') {
                let formid = $(form).attr('id').slice(-4);
                let captchaFunction = `renderRecaptchaform_OfficeContactUsForm_${formid}_Recaptcha_Value`;
                $('#js-add-form').find('form').remove();
                $('#js-add-form').find('.privacy-text').remove();
                $(form).removeClass('active-badge');
                $($('[id*="form-OfficeContactUsForm"]')[0]).append($(form));
                $('#js-modal-form-container').modaal('close');
            }
    }


    openFormModal() {
        $('#js-modal-form-container').modaal({
            content_source: '#js-modal-form-container',
            overlay_opacity: 0.6,
            custom_class: 'js-modal-form-container',
            width: 726,
            close_text: '',
            before_open: () => {
                let form = $('[id*="form-OfficeContactUsForm"]').closest('form')[0];
                $(form).addClass('active-badge');
                $('#js-add-form').append(form);
                $('#js-add-form').append('<div class="privacy-text"><span>By clicking Send Message, you acknowledge and agree to our <a href="/privacy">Privacy Policy.</a></span></div>');
            },
            after_open: () => {
                $('.modaal-close').on('click', this.closeModal);
            }
        });
        $('#js-modal-form-container').modaal('open');
    }
}

export default FormModal;

$(() => {
	const formModal = new FormModal();
	formModal.init();
});